module.exports = __webpack_public_path__ + "static/media/algoritmo2.6a4ed89b.png";